import globalStyle from "../../styles/_global.scss";


const LOADER_QUEUE = [];
let loader;
export default {
  show: (context, contrastMode) => {
    LOADER_QUEUE.push(true);
    if (!loader) {
      let props = null;
      if(contrastMode) {
        props = {
          color:globalStyle.darkTextColor,
          backgroundColor: globalStyle.darkBackgroundColor
        }
      }
      loader = context.$loading.show(props, null);
      
    }
  },

  hide: () => {
    if (LOADER_QUEUE.length) {
      LOADER_QUEUE.shift();
      setTimeout(() => {
        if (LOADER_QUEUE.length === 0) {
          loader.hide();
          loader = null;
        }
      }, 500);
    }
  }
};
